import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { CheckIcon, LockIcon } from 'lucide-react';
const ease = [0.23, 1, 0.32, 1] as const;
export function LiveChangeDemo() {
  const reduce = useReducedMotion();
  const [live, setLive] = useState(false);
  useEffect(() => {
    const timer = window.setTimeout(() => setLive(true), reduce ? 0 : 1800);
    return () => window.clearTimeout(timer);
  }, [reduce]);
  return <div className="relative mx-auto w-full max-w-[720px]" aria-hidden="true" data-id="element-937" data-mp="2hno84hz5bstg">
      {/* The request, as a text message */}
      <motion.div initial={{
      opacity: 0,
      y: 8
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.25,
      ease,
      delay: 0.3
    }} className="relative z-10 -mb-6 ml-auto w-[min(100%,20rem)] rounded-2xl rounded-br-sm bg-brand-red px-4 py-3 text-sm font-medium leading-snug text-white shadow-xl sm:mr-6" data-id="element-938" data-mp="2vfchidi0g36q">
        PIN 1234 change our Friday hours to 11am to 9pm.
      </motion.div>

      {/* The live website */}
      <div className="overflow-hidden rounded-xl border border-gray-200 bg-white shadow-2xl" data-id="element-939" data-mp="2fxmqgxpaelv8">
        <div className="flex items-center gap-3 border-b border-gray-200 bg-gray-50 px-4 py-3" data-id="element-940" data-mp="2kwzehlrw9yze">
          <div className="flex gap-1.5" data-id="element-941" data-mp="2pqakjkovubq9">
            <span className="h-2.5 w-2.5 rounded-full bg-brand-light" data-id="element-942" data-mp="2uoc406q80d29" />
            <span className="h-2.5 w-2.5 rounded-full bg-brand-light" data-id="element-943" data-mp="2uqg5yj4k71zw" />
            <span className="h-2.5 w-2.5 rounded-full bg-brand-light" data-id="element-944" data-mp="1x2ef9rl8zbhv" />
          </div>
          <div className="flex min-w-0 flex-1 items-center gap-1.5 rounded-md bg-white px-3 py-1 text-xs text-brand-gray" data-id="element-945" data-mp="220ppw4jd9q15">
            <LockIcon className="h-3 w-3 flex-shrink-0" data-id="element-946" data-mp="26xpwqho1iwtb" />
            <span className="truncate" data-id="element-947" data-mp="2bydwbrqc4lz5">tacotruck.adroimarketing.com</span>
          </div>
        </div>

        <div className="bg-brand-black px-6 py-8 sm:px-8" data-id="element-948" data-mp="3iezgz6eztsvo">
          <p className="text-xs font-bold uppercase tracking-[0.14em] text-brand-red" data-id="element-949" data-mp="3nd9a7bh5qjen">Las Vegas</p>
          <p className="mt-2 text-2xl font-extrabold text-white sm:text-3xl" data-id="element-950" data-mp="1nb1dbjj59iq7">Taco Truck</p>
          <div className="mt-4 h-2 w-2/3 rounded-full bg-white/20" data-id="element-951" data-mp="1ncul525hu8zs" />
          <div className="mt-2 h-2 w-1/2 rounded-full bg-white/20" data-id="element-952" data-mp="1ibezb7vhrygc" />
        </div>

        <div className="grid gap-6 px-6 py-6 sm:grid-cols-5 sm:px-8" data-id="element-953" data-mp="1waoh2bzcj0mf">
          <div className="sm:col-span-3" data-id="element-954" data-mp="1sae249tkszvf">
            <p className="text-sm font-bold text-brand-black" data-id="element-955" data-mp="1samdfxa1vx4i">Hours</p>
            <dl className="mt-3 divide-y divide-gray-100 text-sm" data-id="element-956" data-mp="14jqqpekgbs44">
              <div className="flex justify-between py-2" data-id="element-957" data-mp="zlfgh2q8vfld">
                <dt className="text-brand-gray" data-id="element-958" data-mp="zn09up0toshn">Mon – Thu</dt>
                <dd className="font-semibold text-brand-black" data-id="element-959" data-mp="1dddk4y16sja5">11am – 8pm</dd>
              </div>
              <div className={`-mx-2 flex justify-between rounded-md px-2 py-2 transition-colors duration-200 ease-out ${live ? 'bg-brand-tint' : ''}`} data-id="element-960" data-mp="18llnc5rfthbk">
                <dt className="text-brand-gray" data-id="element-961" data-mp="kupynhia328j">Friday</dt>
                <dd className="relative font-semibold text-brand-black" data-id="element-962" data-mp="gvqwg4nxljks">
                  <AnimatePresence mode="wait" initial={false} data-id="element-963" data-mp="6rajpk5r0il7">
                    <motion.span key={live ? 'new' : 'old'} initial={{
                    opacity: 0,
                    y: 6
                  }} animate={{
                    opacity: 1,
                    y: 0
                  }} exit={{
                    opacity: 0,
                    y: -6
                  }} transition={{
                    duration: 0.2,
                    ease
                  }} className={`inline-block ${live ? 'text-brand-red' : ''}`} data-id="element-964" data-mp="6oxtkjpu71x2">
                      {live ? '11am – 9pm' : '11am – 8pm'}
                    </motion.span>
                  </AnimatePresence>
                </dd>
              </div>
              <div className="flex justify-between py-2" data-id="element-965" data-mp="fiay6ix9jryz">
                <dt className="text-brand-gray" data-id="element-966" data-mp="kiffuc9wqsqs">Sat – Sun</dt>
                <dd className="font-semibold text-brand-black" data-id="element-967" data-mp="kgkrenzfgihy">10am – 10pm</dd>
              </div>
            </dl>
          </div>
          <div className="space-y-2 sm:col-span-2" data-id="element-968" data-mp="358mv7y4b3ex7">
            <div className="h-20 rounded-md bg-brand-light" data-id="element-969" data-mp="359fteap78w3q" />
            <div className="h-2 w-full rounded-full bg-gray-100" data-id="element-970" data-mp="3lfj41ka9w623" />
            <div className="h-2 w-3/4 rounded-full bg-gray-100" data-id="element-971" data-mp="3lhvsmgajdeo4" />
          </div>
        </div>
      </div>

      {/* Confirmation */}
      <AnimatePresence data-id="element-972" data-mp="3bpg9vgrf0m26">
        {live && <motion.div initial={{
        opacity: 0,
        scale: 0.96,
        y: 6
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} transition={{
        duration: 0.25,
        ease,
        delay: 0.25
      }} className="relative z-10 -mt-5 ml-4 inline-flex items-center gap-2 rounded-full border border-gray-200 bg-white py-2 pl-2 pr-4 text-sm font-semibold text-brand-black shadow-lg sm:ml-8" data-id="element-973" data-mp="3bqhp7xfgrupp">
            <span className="flex h-6 w-6 items-center justify-center rounded-full bg-brand-red text-white" data-id="element-974" data-mp="3uemlkjtskdeh">
              <CheckIcon className="h-3.5 w-3.5" strokeWidth={3} data-id="element-975" data-mp="3pjgyviskeupc" />
            </span>
            Done — checked on your live site
          </motion.div>}
      </AnimatePresence>
    </div>;
}